var appjs;
require(["jquery", "jquery/ui", "mageplaza/core/owl.carousel", "TweenLite", "CSSPlugin", "slick", "select2", "SimpleBar", "mage/translate"], function ($) {
    $.migrateMute = true;

    $(document).ready(function () {
        appjs = {
            WW: window.innerWidth,
            WH: window.innerHeight,
            isMobile: false,
            isTablet: false,
            breakPoint: 1024,
            breakPointMobile: 768,
            delta: .05,
            ie: false,
            init: function () {
                appjs.isMobileDetection();
                appjs.isTabletDetection();
                appjs.toggleFooterLinks();
                appjs.displaySearchBar();
                appjs.carouselUpsell();
                appjs.selectSize();
                appjs.selectFilter();
                appjs.datePickerInit();
                appjs.sidebarManager();
                appjs.slideContentStore();
                appjs.ajaxToCart();
                appjs.sideBarAccount();
                appjs.toastNotif();
                appjs.formInputs();
                appjs.formInputsBind();
                appjs.toggleVisibility();
                appjs.handleFileName();
                appjs.handlePhoneInputs();
                appjs.initDescrProductMacaron();
                appjs.buttonBackToTop();
                appjs.initSelect2Sort();
                appjs.initSelect2Product();
                appjs.inputsRadiosFormCustom();
                // appjs.footerEffectCarousel();
                appjs.select2RegionHelpers();
                appjs.initMenuSticky();
                appjs.mobileMenuHandler();
                if ($('.page-header').length > 0) {
                    // appjs.menuHandler();
                }
                // Catalog product view
                if ($(".catalog-product-view").length > 0) {
                    appjs.initProductDetails();
                }

                // Handle add / remove qty in product page
                if ($(".product-add-form").length > 0) {
                    appjs.changeQty();
                }
                if ($(".delivery-page").length > 0) {
                    appjs.scrollSideDeliveryPage();
                }
                // Handle step back in checkout
                if ($(".back-step-before").length > 0) {
                    appjs.initBackLink();
                }
                // Handle faq toggles
                if ($(".faq-question").length > 0) {
                    appjs.initFaq();
                }
                $(window).resize(function () {
                    appjs.isMobileDetection();
                    appjs.isTabletDetection();
                    appjs.initDescrProductMacaron();
                });

                $(document).ajaxComplete(function () {

                    appjs.initSelect2Sort();
                    appjs.toastNotif();

                });

            },
            initMenuSticky: function () {
                if(!appjs.isTablet){
                    let top = parseInt($('.page-header').height());
                    $(window).on('scroll', function () {
                        if ($(this).scrollTop() > top) {
                            $('.page-header').addClass("sticky");
                            $('.sections.nav-sections').addClass("sticky");
                            // $('.sections.nav-sections').css("top", top);
                        } else {
                            $('.page-header').removeClass("sticky");
                            $('.sections.nav-sections').removeClass("sticky");
                            // $('.sections.nav-sections').css("top", "inherit");
                        }
                    });
                }
            },
            footerEffectCarousel() {
                const footerBlocksWrapper = document.querySelector(".prefooter-content");
                const toAnimate = document.querySelector(".prefooter-content > .row-ph");
                if (footerBlocksWrapper) {
                    const blockWrapper = footerBlocksWrapper.querySelector(".blocks-wrapper");
                    const blockWrapperWidth = blockWrapper.getBoundingClientRect().width;
                    const root = document.querySelector(':root');
                    root.style.setProperty('--blockWrapperWidth', `-${blockWrapperWidth}px`);
                    setTimeout(() => {
                        toAnimate.classList.add('animate');
                    }, 500)
                }
            },
            mobileMenuHandler() {
                $(document).on("click", ".nav-sections-item-content .level0 > .level-top", function(e) {
                    var _this   = $(this),
                        _ul     = _this.parents(".ui-menu"),
                        _li     = _this.parents(".category-item");

                    if( appjs.isTablet ) {
                        $(".mobile-show-ul").removeClass("mobile-show-ul");
                        _li.addClass("mobile-show-ul")

                        /* ajout bouton retour */
                        const observer = new MutationObserver(function(mutationsList, observer) {
                            const submenu = _li.find(".ammenu-items.submenu");
                            if (submenu.length > 0 && submenu.find(".back-button").length === 0) {
                                setTimeout(function(){
                                    submenu.prepend('<li class="back-button"><a href="#" class="ammenu-link -back"><i class="icon-arrow left"></i> ' + $.mage.__('Back') + '</a></li>');
                                }, 100);
                                observer.disconnect();
                            }
                        });

                        observer.observe(_li[0], {
                            childList: true,
                            subtree: true
                        });
                    }
                });
                $(document).on("click", ".all-category a, .submenu .ammenu-link.-back", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if( appjs.isTablet ) {
                        $(".mobile-show-ul").removeClass("mobile-show-ul");
                    }
                    return false;
                });
            },
            menuHandler() {
                // Elements
                const navSection = document.querySelector('.nav-sections');
                const navSectionItems = document.querySelector('.nav-sections .nav-sections-items');
                const promo = document.querySelector('.autopromo-wrapper');
                const header = document.querySelector('.page-header');
                const logo = document.querySelector('.header.content .logo i');

                // PROMO HANDLING ----
                let promoDisplayed = window.getComputedStyle(promo).display !== "none";
                let topOffset = 0;

                // Detect the promo delete
                if (promoDisplayed) {
                    topOffset = promo.getBoundingClientRect().height;
                    const mutationCallback = (mutationList) => {
                        if (mutationList[0].attributeName === "style" && promoDisplayed) {
                            promoDisplayed = false;
                            topOffset = 0;
                            scrollDetect();
                            navSectionItems.classList.add('promo-closed');
                        }
                    };
                    const mutationObserver = new MutationObserver(mutationCallback);
                    mutationObserver.observe(promo, {attributes: true});
                }

                // HANDLE MOBILE / DESKTOP
                const mediaQuery = window.matchMedia('(max-width: 992px)')
                mediaQuery.addListener(handleMobileChange)
                handleMobileChange(mediaQuery)


                // FUNCTIONS
                function handleMobileChange(e) {
                    if (e.matches) {
                        window.removeEventListener("scroll", scrollDetect);
                        if ($('.nav-sections').length) {
                            navSection.removeEventListener("click", handleMenuClick);
                        }
                    } else {
                        window.addEventListener("scroll", scrollDetect);
                        scrollDetect();
                        if ($('.nav-sections').length) {
                            navSection.addEventListener("click", handleMenuClick);
                        }
                    }
                }

                function handleMenuClick(e) {
                    if (document.querySelector("html").classList.contains("nav-open") && (e.target === e.currentTarget || e.target.classList.contains("close-desk-menu"))) {
                        document.querySelector('.action.nav-toggle').click();
                    }
                }

                function scrollDetect() {
                    if (window.scrollY > topOffset && !header.classList.contains("sticky")) {
                        header.classList.add('sticky');
                    }
                    if (window.scrollY <= topOffset && header.classList.contains("sticky")) {
                        header.classList.remove('sticky');
                        logo.style.transform = 'scale(1)';
                    }

                    if (window.scrollY <= topOffset + 50 && header.classList.contains("sticky")) {
                        let scale = 1 - (((window.scrollY - topOffset) * 0.25) / 50);
                        logo.style.transform = `scale(${scale})`;
                    }

                    if (window.scrollY > topOffset + 50 && header.classList.contains("sticky")) {
                        logo.style.transform = `scale(0.75)`;
                    }
                }

            }
            ,
            initProductDetails: function () {
                function findPosition(obj) {
                    let currenttop = 0;
                    if (obj.offsetParent) {
                        do {
                            currenttop += obj.offsetTop;
                        } while ((obj = obj.offsetParent));
                        return [currenttop];
                    }
                }
                $(".super-attribute-select").on("change", function (e) {
                    var _this = $(this),
                        _erField = _this.parents(".product-options-wrapper").find("div[id*='-error']");
                    if (_this.hasClass("mage-error") && _erField.length > 0) {
                        console.log('_erField', _erField);
                    }
                    if (window.matchMedia('(max-width: 991px)').matches) {
                        window.scrollTo({
                            top: findPosition(_this[0]) - 130,
                            behavior: "smooth",
                        });
                    }
                })
            }
            ,

            changeQty: function () {
                $(document).on('click', '.product-add-form .plus-qty', function (e) {
                    e.preventDefault();
                    var _input = $(this).parent().siblings('.input-text.qty'),
                        _value = parseInt(_input.val());
                    _value = _value + 1;
                    _input.val(_value);
                    _input.attr("value", _value);
                    return false;

                });
                $(document).on('click', '.product-add-form .moins-qty', function (e) {
                    e.preventDefault();
                    var _input = $(this).parent().siblings('.input-text.qty'),
                        _value = parseInt(_input.val());
                    _value = _value - 1;
                    if (_value < 1) {
                        _value = 1;
                    }
                    _input.val(_value);
                    _input.attr("value", _value);
                    return false;
                });
            }
            ,

            initBackLink: function () {
                var _backLink = $(".back-step-before");
                $(window).on("hashchange", function (e) {
                    var _hash = window.location.hash.substr(1),
                        _new = window.location.origin + window.location.pathname;
                    if (_hash == "payment") {
                        _new += '#shipping';
                    }
                    if (_hash == "shipping") {
                        _new = 'cart';
                    }
                    _backLink.attr("href", _new);
                });

            }
            ,
            toastNotif: function () {
                if ($('.toast-notif').length > 0) {
                    $('div[role="alert"].toast-notif').addClass("show");
                    $(document).on('click', 'div[role="alert"].toast-notif  .close-toast', function () {
                        $('div[role="alert"]').removeClass("show");
                    });
                }
            }
            ,
            initDescrProductMacaron: function () {
                if ($('.macarons-descr-product').length > 0) {
                    var _macasronDescProdOWL = $('.macarons-descr-product .owl-carousel');
                    if ($(window).width() < appjs.breakPointMobile) {
                        if (!_macasronDescProdOWL.hasClass('owl-loaded')) {
                            _macasronDescProdOWL.owlCarousel({
                                autoHeight: true,
                                responsive: {
                                    0: {
                                        margin: 20,
                                        items: 2,
                                        nav: false,
                                        dots: true
                                    },
                                    768: {
                                        margin: 20,
                                        items: 2,
                                        nav: false,
                                        dots: true
                                    }
                                }
                            });
                        }
                    } else {
                        if (_macasronDescProdOWL.hasClass('owl-loaded')) {
                            _macasronDescProdOWL.trigger('destroy.owl.carousel');
                        }
                    }
                }
            },
            scrollToError: function () {
                if ($('.field-error') && $('.field-error').offset()) {
                    scrollTo({"top": $('.field-error').offset().top - 200, "left": $('.field-error').offset().left});
                }
            }
            ,
            sideBarAccount: function () {
                var _replaceBy = $('.block-collapsible-nav-content .current').text();
                //var _elem = $('.block-collapsible-nav-title').text();
                $('.block-collapsible-nav-title').text(_replaceBy);
            }
            ,

            isMobileDetection: function () {
                appjs.isMobile = $(window).width() < appjs.breakPointMobile;
            }
            ,
            isTabletDetection: function () {
                appjs.isTablet = $(window).width() < appjs.breakPoint;
            }
            ,
            toggleFooterLinks: function () {
                if (appjs.isMobile === true) {
                    const _footerBlockTitle = $('.footer-block-title');
                    _footerBlockTitle.on('click', function () {
                        const _this = $(this),
                            _parent = _this.parent(),
                            _toggleBlock = $(this).next();
                        if (_parent.hasClass('active')) {
                            _parent.removeClass('active');
                            _toggleBlock.slideUp();
                        } else {
                            _parent.addClass('active');
                            _toggleBlock.slideDown({
                                start: function () {
                                    $(this).css({
                                        display: "flex"
                                    })
                                }
                            });
                        }
                    });
                }
            }
            ,
            displaySearchBar: function () {
                // if ($('.block-search-mob').length > 0) {
                    $('.search-header').unbind('click').click(
                        function (e) {
                            e.preventDefault();
                            const _blockSearch = $('.block-search:not(.block-search-mob)');

                            if (_blockSearch.hasClass("open")) {
                                _blockSearch.hide(500)
                                    .removeClass("open");

                            } else {
                                _blockSearch.show(500)
                                    .addClass("open");
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                            }

                        }
                    );
                // }
            }
            ,
            carouselUpsell: function () {
                var _upsellCarousel = $('.upsell-carousel');
                if (_upsellCarousel.length > 0) {
                    _upsellCarousel.owlCarousel({
                        margin: 30,
                        navText: ["<i class='icon-arrow-left'>", "<i class='icon-arrow-right'>"],
                        responsive: {
                            0: {
                                items: 1,
                                nav: true,
                                dots: false
                            },
                            768: {
                                items: 2,
                                nav: true
                            },
                            991: {
                                items: 3,
                                nav: true
                            }
                        }
                    });
                }

            }
            ,
            selectSize: function () {
                $('.catalog-product-view .super-attribute-select').select2({
                    minimumResultsForSearch: "Infinity"
                });
            }
            ,
            selectFilter: function () {
                $('.select2-change').select2({
                    minimumResultsForSearch: "Infinity"
                });
                $('.amlocator-search-container .select2-container--default').css("width", '100%');
            }
            ,
            datePickerInit: function () {
                var _datepicker = $('.datepicker');

                $.datepicker.setDefaults(
                    {
                        firstDay: 1
                    }
                );

                const _datepickerTrigger = $('.datepicker-trigger');
                _datepickerTrigger.on('click', function () {
                    const input = $(this).siblings('input');
                    input.focus();
                });

                if (_datepicker && $('body').hasClass('catalog-category-view')) {
                    $.extend($.datepicker,
                        {
                            _checkOffset: function (inst, offset, isFixed) {
                                offset.top = '100%';
                                offset.right = 0;
                                return offset;
                            }
                        }
                    );

                    _datepicker.datepicker({

                        altField: "#datepicker",
                        closeText: $.mage.__('Fermer'),
                        prevText: $.mage.__('Précédent'),
                        nextText: $.mage.__('Suivant'),
                        currentText: $.mage.__("Aujourd'hui"),
                        monthNames: [$.mage.__('Janvier'), $.mage.__('Février'),
                            $.mage.__('Mars'), $.mage.__('Avril'), $.mage.__('Mai'),
                            $.mage.__('Juin'), $.mage.__('Juillet'), $.mage.__('Août'),
                            $.mage.__('Septembre'), $.mage.__('Octobre'), $.mage.__('Novembre'),
                            $.mage.__('Décembre')],
                        monthNamesShort: [$.mage.__('Janv.'), $.mage.__('Févr.'),
                            $.mage.__('Mars'), $.mage.__('Avril'), $.mage.__('Mai'),
                            $.mage.__('Juin'), $.mage.__('Juil.'), $.mage.__('Août'),
                            $.mage.__('Sept.'), $.mage.__('Oct.'), $.mage.__('Nov.'),
                            $.mage.__('Déc.')],
                        dayNames: [$.mage.__('Dimanche'), $.mage.__('Lundi'),
                            $.mage.__('Mardi'), $.mage.__('Mercredi'), $.mage.__('Jeudi'),
                            $.mage.__('Vendredi'), $.mage.__('Samedi')],
                        dayNamesShort: [$.mage.__('Dim'), $.mage.__('Lun'),
                            $.mage.__('Mar'), $.mage.__('Mer'), $.mage.__('Jeu'),
                            $.mage.__('Ven'), $.mage.__('Sam')],
                        dayNamesMin: [$.mage.__('Dim'), $.mage.__('Lun'),
                            $.mage.__('Mar'), $.mage.__('Mer'), $.mage.__('Jeu'),
                            $.mage.__('Ven'), $.mage.__('Sam')],
                        weekHeader: $.mage.__('Sem.'),
                        dateFormat: 'd M yy',
                        beforeShow: function (input, inst) {

                            setTimeout(function () {

                                var _datepickerParent = _datepicker.parent();
                                $("#ui-datepicker-div").appendTo(_datepickerParent);
                                inst.dpDiv.css({
                                    position: 'absolute',
                                    top: '100%',
                                    left: 'unset',
                                    right: '0'
                                });
                            }, 0);
                        },
                    });

                } else {

                    _datepicker.datepicker({
                        altField: "#datepicker",
                        closeText: $.mage.__('Fermer'),
                        prevText: $.mage.__('Précédent'),
                        nextText: $.mage.__('Suivant'),
                        currentText: $.mage.__("Aujourd'hui"),
                        monthNames: [$.mage.__('Janvier'), $.mage.__('Février'),
                            $.mage.__('Mars'), $.mage.__('Avril'), $.mage.__('Mai'),
                            $.mage.__('Juin'), $.mage.__('Juillet'), $.mage.__('Août'),
                            $.mage.__('Septembre'), $.mage.__('Octobre'), $.mage.__('Novembre'),
                            $.mage.__('Décembre')],
                        monthNamesShort: [$.mage.__('Janv.'), $.mage.__('Févr.'),
                            $.mage.__('Mars'), $.mage.__('Avril'), $.mage.__('Mai'),
                            $.mage.__('Juin'), $.mage.__('Juil.'), $.mage.__('Août'),
                            $.mage.__('Sept.'), $.mage.__('Oct.'), $.mage.__('Nov.'),
                            $.mage.__('Déc.')],
                        dayNames: [$.mage.__('Dimanche'), $.mage.__('Lundi'),
                            $.mage.__('Mardi'), $.mage.__('Mercredi'), $.mage.__('Jeudi'),
                            $.mage.__('Vendredi'), $.mage.__('Samedi')],
                        dayNamesShort: [$.mage.__('Dim'), $.mage.__('Lun'),
                            $.mage.__('Mar'), $.mage.__('Mer'), $.mage.__('Jeu'),
                            $.mage.__('Ven'), $.mage.__('Sam')],
                        dayNamesMin: [$.mage.__('Dim'), $.mage.__('Lun'),
                            $.mage.__('Mar'), $.mage.__('Mer'), $.mage.__('Jeu'),
                            $.mage.__('Ven'), $.mage.__('Sam')],
                        weekHeader: $.mage.__('Sem.'),
                        dateFormat: 'd M yy',
                        onClose: function () {
                            appjs.formInputs();
                        }
                    });

                }

            }
            ,
            sidebarManager: function () {
                const openSidebarAccount = document.getElementsByClassName('open-sidebar-account'),
                    closeSidebarAccount = document.getElementsByClassName('close-sidebar-account'),
                    sidebarAccount = document.getElementsByClassName('sidebar-account')[0];
                appjs.sidebarInit(sidebarAccount, openSidebarAccount, closeSidebarAccount);
            },
            sidebarInit: function (sidebar, openButton, closeButton) {
                const _overlay = document.getElementsByClassName('overlay')[0],
                    _body = document.getElementsByTagName('body')[0];

                if (openButton) {
                    const openSidebar = function () {
                        _overlay.style.right = '0';
                        sidebar.classList.add("active");
                        if (document.querySelector(".action.showcart").classList.contains("active")) {
                            document.querySelector("#btn-minicart-close").click();
                        }
                        // _body.style.overflow = 'hidden';
                        appjs.isMobile ? _body.style.position = 'fixed' : false;
                    };
                    const closeSidebar = function () {
                        _overlay.style.right = '-100%';
                        sidebar.classList.remove("active");
                        // _body.style.overflow = 'unset';
                        appjs.isMobile ? _body.style.position = 'unset' : false;
                        document.body.style.overflow = "initial";
                    };

                    _overlay.addEventListener('click', closeSidebar);

                    $(document).on('click', '#aside-filter-submit', function (e) {
                        closeSidebar();
                        return false;
                    });
                    Array.prototype.forEach.call(openButton, element => {
                        element.addEventListener('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            openSidebar();
                        });
                    });
                    Array.prototype.forEach.call(closeButton, element => {
                        element.addEventListener('click', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            closeSidebar();
                            document.body.style.overflow = "initial";
                            return false;
                        });
                    });
                }
            }
            ,
            slideContentStore: function () {

                if (location.hash) {
                    var id_store_link = location.hash;

                    if (id_store_link) {
                        $('.slide-content-store').addClass("open");
                        $(id_store_link).show();
                    }
                }

                $(document).on('click', '.selector-fiche-store', function (e) {
                    e.preventDefault();
                    $('.encart-store').hide();
                    var _storeId = $(this).attr("data-store");
                    $('.slide-content-store').addClass("open");
                    $('#' + _storeId).show();
                });
                $('.close-store-slider').on('click', function (e) {
                    e.preventDefault();
                    $('.slide-content-store').removeClass("open");
                });
                $('.amlocator-store-list').on('click', function (e) {
                    if ($('.slide-content-store').hasClass('open')) {
                        e.preventDefault();
                        $('.slide-content-store').removeClass("open");
                    }
                });
            }
            ,
            ajaxToCart: function () {
                $('body').on('input', '.adcpopup-summary input.switch--btn', function () {
                    var _switch = $(this);
                    _switch.prop('disabled', true);
                    $.post(
                        "/addtocartpopin/index/index",
                        {
                            product: this.id.substring(7), // remove 'switch-' from the input id
                            add: $(this).is(':checked')
                        },
                        function (result) {
                            _switch.prop('disabled', false);

                            if (typeof window.confirmMessage === 'undefined') {
                                return;
                            }

                            if (result.added === true) {
                                const sections = ['cart'];
                                customerData.invalidate(sections);
                                customerData.reload(sections, true)
                                ajaxConfirmation.add(result.productName);
                                return;
                            }

                            ajaxConfirmation.remove();
                        }
                    );
                });
            }
            ,
            handleFileName: function () {
                var input = $('.contact-index-index .form .file .input-file');
                $(input).on('change', function () {
                    var file_field = $(this).closest('.file');
                    var path_input = file_field.find('.file-name');
                    var files = $(this)[0].files;
                    var file_names = [];
                    for (var i = 0; i < files.length; i++) {
                        file_names.push(files[i].name);
                    }
                    if (file_names.length <= 0) {
                        $('.no-file-selected').show();
                    } else {
                        $('.no-file-selected').hide();
                    }
                    path_input[0].value = file_names.join(', ');
                    path_input.trigger('change');
                });

            }
            ,
            handlePhoneInputs: function () {
                $("input[type=tel]").on('keypress', function (key) {
                    if ((key.charCode < 48 || key.charCode > 57) && key.charCode != 40 && key.charCode != 41 && key.charCode != 45) return false;
                });
            }
            ,
            scrollSideDeliveryPage: function () {
                var links = $('.delivery-page .block-collapsible-nav-content a'),
                    _lis = $('.delivery-page .block-collapsible-nav-content li');
                links.on('click', function (e) {
                    var _this = $(this),
                        _li = _this.parent(),
                        target = $(this.getAttribute('href'));
                    _lis.removeClass("current");
                    _li.addClass("current");
                    if (target.length) {
                        $("html, body").stop().animate({scrollTop: target.offset().top}, 1500);
                    }
                    e.preventDefault();
                    return false;
                });
                /*
                 *   STICKY HANDLER
                 */
                var $sticky = $('.sidebar-main');
                var $stickyrStopper = $('.page-footer');
                if (!!$sticky.offset()) { // make sure ".sticky" element exists
                    var stickyTop = $sticky.offset().top;
                    $(window).on("resize", function () {
                        stickyTop = $sticky.offset().top;
                    });

                    $(window).on("scroll", function () { // scroll event
                        var generalSidebarHeight = $sticky.innerHeight(),
                            stickOffset = 0,
                            stickyStopperPosition = $stickyrStopper.offset().top,
                            stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset,
                            diff = stopPoint + stickOffset,
                            windowTop = $(window).scrollTop(); // returns number
                        if (stopPoint < windowTop) {
                            $sticky.css({position: 'absolute', top: diff});
                            $sticky.removeClass('js-fixed');
                        } else if (stickyTop < windowTop + stickOffset) {
                            $sticky.css({position: 'fixed', top: stickOffset});
                            $sticky.addClass('js-fixed');
                            $sticky
                                .mouseenter(function () {
                                    $sticky.addClass('js-mouseenter');
                                })
                                .mouseleave(function () {
                                    $sticky.removeClass('js-mouseenter');
                                });
                        } else {
                            $sticky.removeAttr('style');
                            $sticky.removeClass('js-fixed');
                        }
                    });
                }
            }
            ,
            formInputsBind: function () {
                // Du to knockout JS, sometimes the function is re-called
                // So we need to "off" the first call
                $("body").off("focus", ".input-text, ._has-datepicker", appjs.focusInput);
                $("body").on("focus", ".input-text, ._has-datepicker", appjs.focusInput);

                // for form amasty custom
                $("body").off("focus", ".amform-form .form-control", appjs.focusInput);
                $("body").on("focus", ".amform-form .form-control", appjs.focusInput);
                $("body").off("blur", ".amform-form .form-control", appjs.blurInput);
                $("body").on("blur", ".amform-form .form-control", appjs.blurInput);

                $("body").off("select2:open", appjs.checkSelects);
                $("body").on("select2:open", appjs.checkSelects);
                // Du to knockout JS, sometimes the function is re-called
                // So we need to "off" the first call
                $("body").off("blur", ".input-text, ._has-datepicker", appjs.blurInput);
                $("body").on("blur", ".input-text, ._has-datepicker", appjs.blurInput);
                $("body").on("change", "._has-datepicker", appjs.blurInput);

                $("body").off("select2:close", appjs.checkSelects);
                $("body").on("select2:close", appjs.checkSelects);
            }
            ,
            formInputs: function () {
                var initSelects = function () {
                    const selects = $("form select:not(.qty_giftbag):not(.qty_almond):not(.qty_candle)");
                    selects.each(function () {
                        if (!$(this).hasClass("select2-hidden-accessible") && !$(this).hasClass("render-by-rendering")) {
                            $(this).addClass("select2-initialized");
                            $(this).select2({
                                minimumResultsForSearch: "Infinity"
                            });
                        }
                        if (!$(this).closest('#product_addtocart_form').length &&
                            !$(this).closest('#attribute-form-bis').length &&
                            !$(this).closest('.delivery-information').length &&
                            !$(this).closest('.field-select-billing').length) {
                            const _optionValue = $(this).find("option[value='']");
                            if (_optionValue.length) {
                                _optionValue.html($.mage.__('-- Aucun --'));
                                $(this).trigger('change')
                            } else {
                                const data = {
                                    id: '',
                                    text: $.mage.__('-- Aucun --')
                                };

                                const newOption = new Option(data.text, data.id, true, true);
                                $(this).prepend(newOption).trigger('change');
                            }
                            const _field = $(this).parents('.field').first(),
                                _valueRenderSelect = $(this).parent().find('.select2-selection__rendered');
                            if ($(this).val() === " " || !$(this).val()) {
                                $(this).removeClass('filled');
                                _field.removeClass("focused");
                                _valueRenderSelect.hide();
                            } else {
                                $(this).addClass('filled');
                                _field.addClass("focused");
                                _valueRenderSelect.show();
                            }
                        }
                    });
                }
                $(document).on('amcform-init-multipage', function (e, form) {
                    initSelects();
                });
                const input = $('.input-text, ._has-datepicker');
                // Check value of each inputs
                input.each(function () {
                    const inputValue = $(this).val(),
                        inputType = $(this).attr('type');
                    if (inputType === "text" || inputType === "email" || inputType === "password" || inputType === "date" || inputType === "tel") {
                        const _field = $(this).parents('.field').first();
                        if (inputValue === "") {
                            $(this).removeClass('filled');
                            _field.removeClass('focused');
                        } else {
                            $(this).addClass('filled');
                            _field.addClass('focused');
                        }
                    }
                });
                initSelects();
            }
            ,
            blurInput: function () {
                const inputValue = $(this).val();
                if (inputValue === "") {
                    $(this).removeClass('filled');
                    $(this).parents('.field').removeClass('focused');
                } else {
                    $(this).addClass('filled');
                    $(this).parents('.field').addClass('focused');
                }
            }
            ,
            focusInput: function () {
                const inputType = $(this).attr('type');
                if (inputType === "text" || inputType === "email" || inputType === "password" || inputType === "date" || inputType === "tel") {
                    $(this).parents('.field').first().addClass('focused');
                }
            }
            ,
            checkSelects: function () {
                const selects = $("form select");
                selects.each(function () {
                    if (!$(this).closest('#product_addtocart_form').length && !$(this).closest('#attribute-form-bis').length && !$(this).closest('.delivery-information').length && !$(this).closest('.field-select-billing').length) {
                        $(this).on("change", function (e) {
                            if ($(this).val() === " " || !$(this).val()) {
                                $(this).removeClass('filled');
                                $(this).parents('.field').removeClass('focused');
                                $(this).parent().find('.select2-selection__rendered').hide();
                            } else {
                                $(this).addClass('filled');
                                $(this).parents('.field').addClass('focused');
                                $(this).parent().find('.select2-selection__rendered').show();
                            }
                        });
                    }
                });
            }
            ,
            toggleVisibility: function () {
                $("body").on('click', '.shipping-information-title', function () {
                    const _toggleBlock = $(this).next();
                    if ($(this).parent().hasClass('opened')) {
                        _toggleBlock.slideUp();
                        $(this).parent().removeClass('opened');
                    } else {
                        _toggleBlock.slideDown({
                            start: function () {
                                if ($(this).parent().hasClass('ship-via')) {
                                    $(this).css({
                                        display: "flex"
                                    })
                                } else {
                                    $(this).css({
                                        display: "block"
                                    })
                                }
                            }
                        });
                        $(this).parent().addClass('opened');
                    }
                });
            }
            ,
            initFaq: function () {
                $(".faq-question").on("click", function (e) {
                    var _this = $(this),
                        _parent = _this.parent(),
                        _answer = _parent.find(".answer");
                    if (_this.hasClass("open")) {
                        _this.removeClass("open");
                        _parent.removeClass("open");
                        TweenLite.to(_answer, .3, {
                            height: 0, onComplete: function () {
                                _answer.removeClass("open").removeAttr("style");
                            }
                        });
                    } else {
                        _this.addClass("open");
                        _parent.addClass("open");
                        TweenLite.set(_answer, {display: "block", height: "auto"});
                        TweenLite.from(_answer, .3, {
                            height: 0, onComplete: function () {
                                _answer.addClass("open").removeAttr("style");
                            }
                        });
                    }
                });

            }
            ,
            buttonBackToTop: function () {
                var btn = document.querySelector('#button-back-top')

                btn.addEventListener('click', function () {
                    var scrollBehavior = {x: 0, y: window.scrollY};


                    TweenLite.to(scrollBehavior, 1, {
                        y: 0,
                        onUpdate: function () {
                            window.scrollTo(0, scrollBehavior.y)
                        },
                    });
                });
            }
            ,
            initSelect2Sort: function () {
                const _sorters = $('.sorter-options');
                _sorters.each(function () {
                    $(this).on('select2:select', function (e) {
                        document.body.style.overflow = "initial";
                    });
                    $(this).select2({
                        allowClear: false,
                        dropdownParent: $(this).parent(),
                        minimumResultsForSearch: Infinity
                    });
                });
            }
            ,
            initSelect2Product: function () {
                const _sorters = $('.amcard-label-block');
                _sorters.each(function () {
                    $(this).select2({
                        allowClear: false,
                        dropdownParent: $(this).parent(),
                        minimumResultsForSearch: Infinity
                    });
                });
            }
            ,
            select2RegionHelpers: function () {
                if ($('#country')) {
                    $('#country').on('change', function () {
                        $("label[for='region_id']").parent().addClass("focused");
                    });
                }
                if ($('body.checkout-index-index')) {
                    $('body.checkout-index-index').on('change', 'select[name="country_id"]', function () {
                        if ($('select[name="region_id"]')) {
                            $('select[name="region_id"]').parents('div.field').addClass("focused");
                        }
                    });
                }
            }
            ,
            inputsRadiosFormCustom: function () {
                if ($('.amcform-page-wrap').length > 0) {
                    $('.form-group.fb-radio').each(function () {
                        const _label = $(this).find('label.fb-radio-group-label');
                        _label.replaceWith("<div class='fb-radio-group-label label'>" + _label.html() + "</div>");
                    })
                }
            }
            ,
        };

        ajaxConfirmation = {
            adc: $('#mgkAdcPopup'),

            add: function (productName) {
                ajaxConfirmation.adc.addClass('show');

                window.confirmMessage([true, productName]);

                ajaxConfirmation.adc.find('.icon-cross').on('click', function () {
                    ajaxConfirmation.remove();
                });

                setTimeout(ajaxConfirmation.remove, 5000);
            },
            remove: function () {
                ajaxConfirmation.adc.find('.icon-cross').off('click');

                ajaxConfirmation.adc.removeClass('show');
                window.confirmMessage([false]);
            }
        };

        appjs.init();

        $.widget("ui.menu", $.ui.menu, {
            _open: function (submenu) {
                var position = $.extend({
                    of: $('.nav-sections-item-content')
                }, this.options.position);

                clearTimeout(this.timer);
                this.element.find(".ui-menu").not(submenu.parents(".ui-menu"))
                    .attr("aria-hidden", "true");
                if (!appjs.isTablet) {
                    submenu
                        .fadeIn()
                        .css("display", "flex")
                        .css("width", "100vw")
                        .removeAttr("aria-hidden")
                        .position(position)
                        .attr("aria-expanded", "true");
                } else {
                    submenu
                        .css("display", "block")
                        .removeAttr("aria-hidden")
                        .attr("aria-expanded", "true");
                }

            }
        });
    });

})
;
